import { personalizeFriendshipJourney as personalizeFriendshipJourneyFn } from '../firebase';

/**
 * @param {Record<string, Record<string, string>>} reflectionAnswers
 * @returns {boolean}
 */
export function hasJourneyReflectionContent(reflectionAnswers) {
  if (!reflectionAnswers || typeof reflectionAnswers !== 'object') {
    return false;
  }
  for (const week of Object.values(reflectionAnswers)) {
    if (!week || typeof week !== 'object') continue;
    for (const v of Object.values(week)) {
      if (typeof v === 'string' && v.trim().length > 0) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Calls the secured Cloud Function; OpenAI key stays on the server.
 * @param {{ reflectionAnswers: object, locale?: string, friendName?: string | null }} input
 */
export async function fetchJourneyPersonalization(input) {
  return personalizeFriendshipJourneyFn({
    reflectionAnswers: input.reflectionAnswers,
    locale: input.locale || 'en',
    friendName: input.friendName || undefined
  });
}
